// extracted by mini-css-extract-plugin
module.exports = {"anchor":"FlexibleDateBestPriceInner-module__anchor___18riT","card":"FlexibleDateBestPriceInner-module__card___XGdl4"};